export enum BillingTermType {
  Revision = 'revision',
  Binary = 'binary',
}

export type BillingTerm = {
  id: number;
  quantity: number;
  organizationId: number;
  termStart: Date;
  termEnd: Date;
  type: BillingTermType;
  createdBy: string;
  createdAt: Date;
};

export type BillingTermWithUsageFields = BillingTerm & {
  isActive: boolean;
  usage: number;
};
